import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locationId: null,
  selectedLocation: null,
  departments: [],
};

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocationIdSlice: (state, action) => {
      state.locationId = action.payload.locationId;
    },
    setSelectedLocationData: (state, action) => {
      state.selectedLocation = action.payload.selectedLocation;
    },
    setDepartmentsToRedux: (state, action) => {
      state.departments = action.payload.departments;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLocationIdSlice, setSelectedLocationData, setDepartmentsToRedux } =
  locationSlice.actions;

export const getLocationId = state => state.location.locationId;
export const getSelectedLocation = state => state.location.selectedLocation;
export const getDepartments = state => state.location.departments;

export default locationSlice.reducer;
